<template>
  <span class="ui-chip" :class="[tone && tone !== 'plain' && `ui-chip--${tone}`, pill && 'ui-chip--pill', tag && 'ui-chip--tag']">
    <i v-if="dot" class="ui-dot"></i>
    <v-icon v-else-if="icon" size="13" color="currentColor">{{ icon }}</v-icon>
    <slot></slot>
  </span>
</template>

<script>
/** Oznaka stanja. tone: plain | ok | warn | bad | blue | accent; pill je zaobljena do kraja; tag je mala oznaka velikim slovima; dot (tačka) ili icon ispred teksta. */
export default {
  name: "UiChip",
  props: {
    tone: { type: String, default: "plain" },
    pill: { type: Boolean, default: false },
    tag: { type: Boolean, default: false },
    dot: { type: Boolean, default: false },
    icon: { type: String, default: "" },
  },
};
</script>
